import { isEmpty, startCase } from "lodash";
import React, { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import DropDown from "./DropDown";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import iconfromto from "../../assets/images/icon-fromto.png";

const OtherMarkets = ({ title, data }) => {
  const [showMatch, setShowMatch] = useState(false);
  let { user } = useContext(AuthContext);
  const [selectData, setSelectData] = useState("");
  const [id, setId] = useState("");
  const navigate = useNavigate();

  return (
    <div className="risk-management-table">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h2 className="common-heading">Other Markets</h2>
        <div>
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            Download
          </Button>{" "}
          <Button className="view-btn" style={{ fontWeight: "600" }}>
            <i
              style={{ transform: "rotateY(180deg)" }}
              className="fas fa-redo-alt"
            ></i>
          </Button>
        </div>
      </div>

      <div className="account-table match-odd-table">
        <div className="responsive">
          <Table>
            <thead>
              <tr>
                <td width="10%" rowSpan="2">
                  <strong> Sports</strong>
                </td>
                <td width="10%" rowSpan="2">
                  <strong> Market Date</strong>
                </td>
                <td rowSpan="2">
                  <strong>Event/Market Name</strong>
                </td>

                <td width="15%" rowSpan="2" className="text-right">
                  <strong>Matched Amount</strong>
                </td>
              </tr>
            </thead>
            {data?.length > 0 ? (
              <tbody className="match-tbody">
                {data?.map((res, index) => {
                  return (
                    <tr key={index + 1}>
                      <>
                        <td className="text-start">
                          <p className="blue-text">{startCase(res.gameType)}</p>
                        </td>
                        <td className="text-start">
                          {helpers.matchDateTimeNew(
                            res?.eventDateTime,
                            user.timeZone
                          )}{" "}
                        </td>
                      </>

                      <td className="bg-yellow border-0 risk-match-name">
                        <a>
                          <strong style={{ marginLeft: "10px" }}>
                            <Link
                              onClick={() =>
                                window
                                  .open(
                                    `/risk-betfair/${res?.eventId}/${res?.marketId}`,
                                    "_blank",
                                    "width=900, height=700"
                                  )
                                  .focus()
                              }
                            >
                              {res.eventName}
                            </Link>
                          </strong>{" "}
                          <img className="fromto" src={iconfromto} />
                          <span className="ms-3">
                            {res?.market ? res?.market : "Bookmaker"}{" "}
                          </span>
                        </a>
                      </td>

                      <td className="border-right-0 text-right">0.00</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tr>
                <td colSpan={7}>No Data</td>
              </tr>
            )}
          </Table>
        </div>
      </div>
    </div>
  );
};

export default OtherMarkets;
